export default __webpack_public_path__ + "static/media/completeCheckIcon.1ddb8fd6.svg";